export const topicPrefix = "ap/hdata/";

export const ERROR_TYPE_NOT_CONNECTED = -1;
export const ERROR_TYPE_NO_ERROR = 1;